// extracted by mini-css-extract-plugin
export default {"Cartbtn":"CartButton_Cartbtn__nNWYI","Cartbump":"CartButton_Cartbump__Q2jvD","count":"CartButton_count__kgBpe","rotated-image":"CartButton_rotated-image__U56MC"};